import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import { Table, ButtonBase, Tooltip, TableRow, TableHead, TableBody } from '@mui/material';

import { withStyles } from '@mui/styles';

import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import CopyIcon from '@mui/icons-material/FilterNone';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import DeleteIcon from '@mui/icons-material/DeleteForever';

import Node from '../../../common/Node';
import Cell from '../../../common/Cell';
import CommonStyles from '../../../common/CommonStyles';
import JelsStyles from '../JelsStyles';

import { jelTypes } from '../../../constants';
import JelListViewBtn from './JelListViewBtn';

const styles = {
  ...CommonStyles,
  ...JelsStyles,
};

export default connect((state) => ({
  jels: state.jels,
  accounts_tbox: state.meta.accounts_tbox,
  setup_accounts: state.meta.setup_accounts,
}))(
  withStyles(styles)(
    ({
      jels,
      type,
      rows,
      classes,
      deleteJel,
      nodesData,
      copyElement,
      isDashboard,
      newModalData,
      accounts_tbox,
      toggleEditModal,
      getJelsKeyByTab,
      openDeleteJelModal,
      toggleEditDashboardModal,
    }) => {
      useEffect(() => {
        const theadCells = document.querySelectorAll('th');

        theadCells.forEach((theadCell) => {
          makeResizable(theadCell);
        });
      }, []);

      const makeResizable = (theadCell) => {
        if (!theadCell) return;

        const resizer = theadCell.querySelector('.thead-resizer');

        if (resizer)
          resizer.addEventListener('mousedown', function (e) {
            e.preventDefault();

            resizer.querySelector('div').style.width = '2px';
            resizer.querySelector('div').style.backgroundColor = '#0047FF';

            window.addEventListener('mousemove', resize);
            window.addEventListener('mouseup', stopResize);
          });

        let width = 0;

        const resize = (e) => {
          let newPos;
          newPos = e.clientX - theadCell.getBoundingClientRect().right + 6;

          resizer.style.display = 'flex';
          resizer.style.right = -newPos + 'px';
          width = e.clientX - theadCell.getBoundingClientRect().left + 6;
        };

        function stopResize() {
          window.removeEventListener('mousemove', resize);

          resizer.querySelector('div').style.backgroundColor = '';
          resizer.querySelector('div').style.width = '1px';

          const newWidth = width > 50 ? `${width}px` : '50px';

          resizer.style.right = '0';
          theadCell.style.width = newWidth;
        }
      };

      const getSettings = (jel) => {
        const settings = [];

        if (jel.type === jelTypes.table) {
          if (jel.show_index) settings.push('Index');
          if (jel.show_title) settings.push('Title');
          if (jel.show_export) settings.push('Export');
        } else if (jel.type === jelTypes.form) {
          if (jel.is_mobile) settings.push('Mobile');
          if (jel.tabs) settings.push('Tabs');
          if (jel.submit_only) settings.push('Submit only');
        }
        return settings.join(', ');
      };

      const jelType = type === jelTypes.dashboard
        ? 'dashboard'
        : type === jelTypes.table
          ? 'trpls_tbl'
          : type === jelTypes.form
            ? 'trpls_frm'
            : '';

      const getImportedJels = (importedApp) => {
        if (!importedApp[jelType]) return [];
        return importedApp[jelType]
          .filter(jel => isDashboard ? jel.is_dashboard : !jel.is_dashboard)
          .map(jel => jel.id);
      };

      const findJelInJelsArr = (anotherJelArr, viewId) => {
        return anotherJelArr.find(item => item.id === viewId);
      };

      const getJelTableRow = (jelIds, isImportedJel) => {
        return jelIds.map((jelId, jelIndex) => {
          let accountGroupTitle = '';
          const jel = jels.jelData[jelId];

          if (!jel) return null;

          if (type === 'user_menu' && Array.isArray(jel.group)) {
            jel.group.forEach((group, groupIndex) => {
              const groupTitle = accounts_tbox.nodes[group].title;
              const comma = groupIndex === jel.group.length - 1 ? '' : ', ';

              accountGroupTitle += `${groupTitle}${comma}`;
            });
          }

          let isInAnotherJel = [];

          if (type === jelTypes.table) {
            jels.forms.forEach((id) => {
              const frm = jels.jelData[id];

              frm.groups && frm.groups.forEach((row) => {
                row && row.length && row.forEach((group) => {
                  if (group.type === 'table' && group.tableId === jel.id)
                    isInAnotherJel.push({ type: jelTypes.form, title: `${frm.id} ${frm.title}`, id: frm.id });

                  if (group.type === 'links')
                    group.links.forEach((index) => {
                      if (index.jel === jel.id)
                        isInAnotherJel.push({ type: jelTypes.form, title: `${frm.id} ${frm.title}`, id: frm.id });
                    });
                });
              });
            });
          } else if (type === jelTypes.form) {
            jels.tables.forEach((id) => {
              const tbl = jels.jelData[id];

              if (tbl.buttons && tbl.buttons.editNode && jel.id === tbl.buttons.editNode)
                isInAnotherJel.push({ type: jelTypes.table, title: `${tbl.id} ${tbl.title}`, id: tbl.id });
            });

            jels.forms.forEach((id) => {
              const frm = jels.jelData[id];

              frm.groups && frm.groups.forEach((row) => {
                row.forEach((group) => {
                  if (group.type === 'links') {
                    group.links.forEach((link) => {
                      if (link.jel === jel.id && (!findJelInJelsArr(isInAnotherJel, frm.id)))
                        isInAnotherJel.push({ type: jelTypes.form, title: `${frm.id} ${frm.title}`, id: frm.id });
                    });
                  }

                  if (group.items && group.items.length) {
                    group.items.forEach(item => {
                      if (item.obj_editable_frm && item.obj_editable_frm === jel.id
                        && (!findJelInJelsArr(isInAnotherJel, frm.id)))
                        isInAnotherJel.push({ type: jelTypes.form, title: `${frm.id} ${frm.title}`, id: frm.id });
                    })
                  }

                  if (group.type === 'accordeon' && (group.frmId === jel.id || group.frmEditId === jel.id) &&
                  (!findJelInJelsArr(isInAnotherJel, frm.id)))
                    isInAnotherJel.push({ type: jelTypes.form, title: `${frm.id} ${frm.title}`, id: frm.id });
                });
              });
            });

            jels.dashboards.forEach((id) => {
              const dashboard = jels.jelData[id];

              if (dashboard.views)
                dashboard.views.forEach((view) => {
                  if (view.value === jel.id) isInAnotherJel.push(dashboard);
                });
            });
          }

          return (
            <TableRow
              id={jel.id}
              key={jelIndex}
              className={classes.tableRow}
              style={{ backgroundColor: isNaN(jel.id) ? '#DBD9E7' : '' }}
            >
              <Cell
                className={classes.tableCellId}
                style={{
                  paddingLeft: '10px',
                }}
              >
                {jel.id && !jel.draft ? (
                  <span
                    className={classes.pointer}
                    onClick={() => {
                      toggleEditModal({
                        isOpened: true,
                        data: jel,
                        type,
                      });
                    }}
                  >
                    {jel.id}
                  </span>
                ) : (
                  <span className={`${classes.red}`} style={{ fontSize: 10 }}>
                    not&nbsp;saved
                  </span>
                )}
              </Cell>

              <Cell
                className={classes.tableCellTitle}
              >
                <span
                  title={jel.title}
                  onClick={() => {
                    toggleEditModal({
                      isOpened: true,
                      data: jel,
                      type,
                    });
                  }}
                  className={`${classes.elementHeading} ${classes.pointer}`}
                >
                  {jel.title || 'No title'}
                </span>
              </Cell>

              <Cell
                className={classes.tableCellConcept}
                style={{ overflow: 'hidden' }}
              >
                {(type === jelTypes.table || type === jelTypes.form) && !nodesData[jel.concept] ? null : (type ===
                  jelTypes.table || type === jelTypes.form) && nodesData[jel.concept] ? (
                  <Node isLink
                    nodeId={jel.concept}
                    size="sm"
                    nodes={nodesData}
                    node={nodesData[jel.concept]}
                  />
                ) : (
                  <span>{accountGroupTitle || 'None'}</span>
                )}
              </Cell>

              <Cell
                style={{ overflow: 'hidden' }}
              >
                <div className={classes.spaceBetween}>
                  {(type === jelTypes.table || type === jelTypes.form) && jel.id ? (
                    <div className={classes.jelsContainer}>
                      {isInAnotherJel.map((viewData, jelIndex) => {
                        return (
                          <React.Fragment key={jelIndex}>
                            <JelListViewBtn
                              viewData={viewData}
                              toggleEditModal={toggleEditModal}
                              toggleEditDashboardModal={toggleEditDashboardModal}
                            />
                          </React.Fragment>
                        )
                      })}
                    </div>
                  ) : (
                    <div />
                  )}

                  <div className={classes.alignCenter}>
                    <div className={classes.jelSettings}>
                      {getSettings(jel)}
                    </div>

                    <ButtonBase
                      className={classes.mr15}
                      onClick={() => {
                        toggleEditModal({
                          isOpened: true,
                          data: jel,
                          type,
                        });
                      }}
                    >
                      <Tooltip
                        title="Edit"
                        placement="top"
                        classes={{
                          tooltip: classes.muiTooltip,
                        }}
                      >
                        <EditIcon className={classes.tableRowBtn} />
                      </Tooltip>
                    </ButtonBase>

                    {isNaN(jel.id) ? <div style={{ width: '34px' }}/> :
                      <ButtonBase className={classes.mr15}>
                        <Tooltip
                          placement="top"
                          title={`Open ${jel.title} in new tab`}
                          classes={{
                            tooltip: classes.muiTooltip,
                          }}
                        >
                          <a style={{ marginTop: '5px' }} target="_blank" rel="noreferrer" href={`/frm?id=${jel.id}`}>
                            <OpenInNewIcon className={classes.tableRowBtn}/>
                          </a>
                        </Tooltip>
                      </ButtonBase>
                    }

                    {isNaN(jel.id) ? <div style={{ width: '34px' }}/> :
                      <ButtonBase
                        className={classes.mr15}
                        style={{
                          visibility: `${isImportedJel ? 'hidden' : ''}`,
                        }}
                        onClick={() => {
                          copyElement(jel, (jelId) => {
                            if (jelId) {
                              const el = document.getElementById(jelId);
                              el.scrollIntoView({ block: "center" });
                            }
                          });
                        }}
                      >
                        <Tooltip
                          title="Copy"
                          placement="top"
                          classes={{
                            tooltip: classes.muiTooltip,
                          }}
                        >
                          <CopyIcon className={classes.tableRowBtn} style={{ fontSize: 18 }} />
                        </Tooltip>
                      </ButtonBase>
                    }

                    <ButtonBase
                      className={classes.mr15}
                      style={{
                        visibility: `${isImportedJel ? 'hidden' : ''}`,
                      }}
                      onClick={() => {
                        if (isNaN(jel.id)) {
                          const jelKey = getJelsKeyByTab();
                          deleteJel(jel.id, jelKey);
                        } else openDeleteJelModal(jel.id, type);
                      }}
                    >
                      <Tooltip
                        title="Delete"
                        placement="top"
                        classes={{
                          tooltip: classes.muiTooltip,
                        }}
                      >
                        <DeleteIcon className={`${classes.tableRowBtn} ${classes.tableRowDeleteBtn}`} />
                      </Tooltip>
                    </ButtonBase>
                  </div>
                </div>
              </Cell>
            </TableRow>
          );
        });
      };

      return (
        <div>
        <Table className={`jel-table`} style={{ tableLayout: 'fixed' }}>
          <TableHead>
            <TableRow>
              <Cell
                className={`thead-id ${classes.tableCellId}`}
                style={{ paddingLeft: 30 }}
              >
                <div className={classes.alignCenter}>
                  <span className={classes.columnHeadingGeneral}>Id</span>
                </div>
              </Cell>

              <Cell className={`thead-title ${classes.tableCellTitle}`}>
                <div className={classes.alignCenter}>
                  <div className={`thead-resizer ${classes.theadResizer}`}>
                    <div className={classes.theadResizerLine} />
                  </div>
                  <span className={classes.columnHeadingGeneral}>Title</span>
                </div>
              </Cell>

              <Cell className={`thead-concept ${classes.tableCellConcept}`}>
                <div className={classes.alignCenter}>
                  <div className={`thead-resizer ${classes.theadResizer}`}>
                    <div className={classes.theadResizerLine} />
                  </div>
                  <span className={classes.columnHeadingGeneral}>Concept</span>
                </div>
              </Cell>

              {type === jelTypes.table || type === jelTypes.form ? (
                <Cell
                  className={`thead-used-in`}
                  style={{
                    boxSizing: 'border-box',
                    position: 'relative',
                    display: 'flex',
                    justifyContent: 'space-between'
                  }}>
                  <div className={classes.alignCenter}>
                    <div className={`thead-resizer ${classes.theadResizer}`}>
                      <div className={classes.theadResizerLine} />
                    </div>
                    <span className={classes.columnHeadingGeneral}>Used in</span>
                  </div>

                  <div className={classes.alignCenter} style={{ width: "305px" }}>
                    <span className={classes.columnHeadingGeneral}>Settings</span>
                  </div>
                </Cell>
              ) : null}
            </TableRow>
          </TableHead>

          <TableBody style={{ background: '#fff' }}>
            {getJelTableRow(rows)}

            <TableRow style={{ height: 39 }}>
              <Cell
                colSpan={4}
                style={{ paddingLeft: 30 }}
                onClick={() =>
                  toggleEditModal({
                    type: type,
                    isOpened: true,
                    data: newModalData,
                  })
                }
              >
                <ButtonBase className={`${classes.btn} ${classes.secondaryBtn}`}>
                  <AddIcon style={{ fontSize: 13, color: '#347CFF' }} />
                  Add new {type}
                </ButtonBase>
              </Cell>
            </TableRow>
          </TableBody>
        </Table>

        {jels.importedJels && jels.importedJels.some(importedApp => getImportedJels(importedApp).length) && (
          <div className={classes.mt20} style={{ padding: '5px 0', backgroundColor: '#FFFF' }}>
            {jels.importedJels.map((importedApp, index) => {
              const importedJels = getImportedJels(importedApp);
              if (importedJels.length) {
                return (
                  <div key={index}>
                    <div className={`${classes.columnHeadingGeneral} ${classes.ml10}`}>
                      Imported from setup {importedApp.app_id}
                    </div>

                    <Table className={`jel-table`} style={{ tableLayout: 'fixed' }}>
                      <TableBody style={{ background: '#fff' }}>
                        {getJelTableRow(importedJels, true)}
                      </TableBody>
                    </Table>
                  </div>
                );
              }

              return null;
            })}
          </div>
        )}
      </div>
      );
    }
  )
);
